
import { ref } from '@nuxtjs/composition-api';


export default {
  props: {
    markdown: {
      default: '',
      type: String
    }
  },
  setup(props) {
    const html = ref('')

    const getHtml = async () => {
      const { richTextFromMarkdown } = await import('@contentful/rich-text-from-markdown')
      const { documentToHtmlString } = await import('@contentful/rich-text-html-renderer');

      richTextFromMarkdown(props.markdown).then(res => {
        html.value = documentToHtmlString(res)
        return html
      })
    }

    getHtml()

    return { html, getHtml }
  },
  watch: {
    markdown () {
      this.getHtml()
    }
  }
}
